/**
 * @param lang {string}
 * @return {string}
 */
module.exports = function convertHtmlLangToLocale(lang) {
    const langLowercase = lang.toLowerCase();

    const langPieces = langLowercase.split("-");

    const locale = langPieces.length ? langPieces[0] : "";

    const localesWeCareAbout = ['en', 'en-gb', 'es', 'fr', 'de', 'nl'];

    const weCareAboutThisLocale = localesWeCareAbout.includes(locale);

    return weCareAboutThisLocale ? locale : "";
}